import React from "react";
import {WealthyEnv} from "helpers";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

const linkedinImage = `${WealthyEnv.HOMEPAGE_CDN_URL}/founder-card-linkedIn-about-us.svg`;

const PersonCard = ({image, name, position, description, background, linkedinUrl}) => {
  // const isMobile = typeof window !== "undefined" ? window.innerWidth <= 768 : false;

  return (
    <CardContainer background={background}>
      <ImageContainer>
        <FounderImage
          alt={`${name} - Co Founder of Wealthy`}
          loading="lazy"
          src={image}
          width={516}
          height={720}
          sizes="(max-width: 768px) 15rem, 25rem"
          decoding="async"
        />
      </ImageContainer>
      <CardContent>
        <Name>{name}</Name>
        <Position>
          {position} <Dot>•</Dot>
          <LinkedInIcon href={linkedinUrl} target="_blank" rel="noopener noreferrer" aria-label="Open LinkedIn (opens in new tab)">
            <LinkedInImage
              alt="LinkedIn Icon"
              src={linkedinImage}
              width={24}
              height={24}
              decoding="async"
            />
          </LinkedInIcon>
        </Position>
        <Description>{description}</Description>
      </CardContent>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: center;
  background: ${(props) => props.background || "#fff"};
  border-radius: 18px;
  overflow: hidden;
  min-height: 425px;
  margin-bottom: 24px;
  padding: 0 5rem;
  gap: 2rem;

  @media (max-width: 768px) {
    flex: unset;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: 10px 12px;
    min-height: unset;
    gap: 16px;
    margin-top: 1rem;
  }
`;

const ImageContainer = styled.div`
  display:flex;
  justify-content: center;
  max-width: 25rem;
  height: 40rem;
  align-self: flex-end;

  @media (max-width: 768px) {
    width: 15rem;
    height: 15rem;
    border-radius: 50%;
    align-self: center;
    border: 1px solid #D9D9D9;
    }
`;


const CardContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-left: auto;

  @media (min-width: 768px) {
    align-items: flex-start;
    text-align: left;

  }
`;

const Name = styled.h2`
  font-size: 3.6rem;
  font-family: 'Lato';
  font-weight: 600;
  line-height: 1.2;
  color: #1C1C1C;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Position = styled.h3`
  margin: 0 0 16px 0;
  color: #1D1D1F;
  font-family: 'Lato';
  font-size: 2rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 6px;

@media (max-width: 768px) {
  font-size: 1.6rem;
}
`;

const Dot = styled.span`
  font-size: 1.2em;
  margin: 0 4px;
`;

const LinkedInIcon = styled(SafeLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

const LinkedInImage = styled.img`
  width: 15px;
  height: 15px;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

const Description = styled.p`
  margin-top: 24px;
  color: #6F6F6F;
  font-family: 'Lato';
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 3.2rem;

  @media (max-width: 768px) {
    margin-top: 0.5rem;
    font-size: 1.4rem;
    max-width: 80%;
    text-align: center;
  }
`;
const FounderImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
  align-self: flex-end;

  @media (max-width: 768px) {
    object-fit: contain;
    width: 100%;
    height: 100%;
    border-radius:50%;
  }
`;

export default PersonCard;
